import gql from "graphql-tag";

export const GET_IBKR_ACCOUNT_DETAILS = gql`
  query GetIBKRAccountDetails($orderId: ID!) {
    getIBKRAccountDetails(orderId: $orderId)
  }
`;
